import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isEqual } from 'lodash';

import SettingsContext from '../../context/SettingsContext';

import { MainContent, PageHeading } from '../../components/Shell/Content';
import AppContext from '../../context/AppContext';
import WidgetDashboard from '../../components/WidgetDashboard';

import { getAvailableWidgets } from '../../components/helpers/constants';

import useAsync from '../../hooks/useAsync';

import { getWidgetsByType } from '../../api/company';
import { useApp } from '../../context/AppContextBeta';
import { classNames } from '../../components/helpers/functions';
import LiveFeed from '../../components/WidgetDashboard/widgets/LiveFeed';

const Dashboard = () => {
	const { user, isDesktop } = useApp();
	const {
		settings,
		loading: isLoadingSettings,
		update: updateSettings,
	} = useContext(SettingsContext);

	const { value: widgets, status: isLoadingWidgets } = useAsync(
		getWidgetsByType,
		{
			defaultPayload: { type: 'dashboard' },
		},
	);
	return (
		<MainContent maxWidth="w-full">
			<h1
				className={classNames(
					'text-2xl/8 font-semibold text-zinc-950 sm:text-xl/8',
					!isDesktop ? 'mb-8' : '',
				)}
			>
				Hello{user?.firstName && `, ${user.firstName}`}! 👋
			</h1>

			{/*<LiveFeed />*/}

			<div>
				<WidgetDashboard
					dashboardType="dashboard"
					widgetSettings={settings?.user?.widgetSettings}
					isLoading={isLoadingWidgets === 'pending' || isLoadingSettings}
					availableWidgets={getAvailableWidgets(
						'dashboard',
						widgets?.map((w) => w.key),
					)}
					activeWidgets={
						settings?.user?.widgets?.dashboard || [
							'dashboard-system-overview',
							'dashboard-tickets-all',
							'system-get-started',
						]
					}
					onChange={(state) => {
						if (
							settings?.user?.widgets?.dashboard?.length !== state?.length ||
							!isEqual(settings?.user?.widgets?.dashboard, state)
						) {
							updateSettings({
								type: 'user',
								key: 'widgets',
								value: {
									...settings?.user?.widgets,
									dashboard: state,
								},
							});
						}
					}}
				/>
			</div>
		</MainContent>
	);
};

export default Dashboard;
